export default "__VITE_ASSET__9b61b543__"